import React from 'react';
import { Box, ToggleButtonGroup, ToggleButton } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import NotesIcon from '@mui/icons-material/Notes';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import GroupIcon from '@mui/icons-material/Group';
import LayersIcon from '@mui/icons-material/Layers';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PaginationControls from './PaginationControls';

export default function EventFilters({
  selectedFilters,
  onFilterChange,
  pageSize,
  onPageSizeChange,
  currentPage,
  totalEvents,
  onPreviousPage,
  onNextPage,
  hasMore
}) {
  // Convert object format to array for ToggleButtonGroup
  const selectedArray = Object.keys(selectedFilters).filter(key => selectedFilters[key]);

  const handleChange = (event, newFilters) => {
    if (newFilters.length > 0) {
      // Convert array back to object format
      const newFilterObj = Object.keys(selectedFilters).reduce((obj, key) => {
        obj[key] = newFilters.includes(key);
        return obj;
      }, {});
      onFilterChange(newFilterObj);
    }
  };

  const buttonStyle = (isSelected) => ({
    color: isSelected ? 'primary.main' : 'grey.500',
    '&.Mui-selected': { color: 'primary.main', backgroundColor: 'action.selected' },
    p: 0.25,
    minWidth: 28,
    minHeight: 28
  });

  return (
    <Box sx={{ mt: 0.5, pt: 0.5, borderTop: 1, borderColor: 'divider' }}>
      {/* Single row with filters on left, controls on right */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
        {/* Event Type Filters - Left side */}
        <ToggleButtonGroup
          value={selectedArray}
          onChange={handleChange}
          aria-label="event type filters"
          size="small"
        >
          <ToggleButton
            value="match"
            aria-label="match events"
            sx={buttonStyle(selectedFilters.match)}
          >
            <PersonSearchIcon sx={{ fontSize: 16 }} />
          </ToggleButton>
          <ToggleButton
            value="multi_dataset_match"
            aria-label="multi-dataset match events"
            sx={buttonStyle(selectedFilters.multi_dataset_match)}
          >
            <LayersIcon sx={{ fontSize: 16 }} />
          </ToggleButton>
          <ToggleButton
            value="promotion"
            aria-label="promotion events"
            sx={buttonStyle(selectedFilters.promotion)}
          >
            <PersonAddIcon sx={{ fontSize: 16 }} />
          </ToggleButton>
          <ToggleButton
            value="detection"
            aria-label="detection events"
            sx={buttonStyle(selectedFilters.detection)}
          >
            <VisibilityIcon sx={{ fontSize: 16 }} />
          </ToggleButton>
          <ToggleButton
            value="note"
            aria-label="note events"
            sx={buttonStyle(selectedFilters.note)}
          >
            <NotesIcon sx={{ fontSize: 16 }} />
          </ToggleButton>
          <ToggleButton
            value="assignment"
            aria-label="assignment events"
            sx={buttonStyle(selectedFilters.assignment)}
          >
            <AssignmentIcon sx={{ fontSize: 16 }} />
          </ToggleButton>
          <ToggleButton
            value="group_match"
            aria-label="group match events"
            sx={buttonStyle(selectedFilters.group_match)}
          >
            <GroupIcon sx={{ fontSize: 16 }} />
          </ToggleButton>
        </ToggleButtonGroup>

        {/* Pagination Controls - Right side */}
        <PaginationControls
          pageSize={pageSize}
          onPageSizeChange={onPageSizeChange}
          currentPage={currentPage}
          totalEvents={totalEvents}
          onPreviousPage={onPreviousPage}
          onNextPage={onNextPage}
          hasMore={hasMore}
        />
      </Box>
    </Box>
  );
}
